import xhrService from '../xhrService';

const baseUrl = '/api/projects';

export type ProjectInspectionTemplate = {
  id: number;
  project_id: number;
  inspection_template_id: number;
  is_primary: boolean;
  is_active: boolean;
  next_inspection_date: string;
  inspection_compliance_required: boolean;
  inspector_id: number | null;
  inspector_name: string | null;
  inspection_interval_id: number;
  is_inspection_certification_timeline_enabled: boolean;
  is_asset_tracking_enabled: boolean;
  inspection_template: {
    id: number;
    name: string;
    inspection_type_id: number;
    inspectionTemplateType: {
      id: number;
      name: string;
    };
  };
};

export type ProjectInspectionTemplatesResponse = {
  success: boolean;
  data: ProjectInspectionTemplate[];
  count: number;
};

export const projectInspectionTemplatesApi = {
  /**
   * Get all inspection templates for a project
   * @param projectId - The project ID
   * @returns Promise with project inspection templates
   */
  index: async (projectId: number): Promise<ProjectInspectionTemplatesResponse> => {
    return xhrService
      .get(`${baseUrl}/${projectId}/inspection-templates`)
      .then((response) => response.data);
  },

  /**
   * Get unique template types for a project (id and name only)
   * @param projectId - The project ID
   * @returns Promise with unique template types
   */
  getUniqueTemplateTypes: async (projectId: number): Promise<{ id: number; name: string }[]> => {
    return xhrService
      .get(`${baseUrl}/${projectId}/inspection-template-types/unique`)
      .then((response) => response.data?.data ?? response.data);
  },
};

export default projectInspectionTemplatesApi;
